import { render, staticRenderFns } from "./addUserByCompany.vue?vue&type=template&id=4c5fff59&"
import script from "./addUserByCompany.vue?vue&type=script&lang=js&"
export * from "./addUserByCompany.vue?vue&type=script&lang=js&"
import style0 from "./addUserByCompany.vue?vue&type=style&index=0&id=4c5fff59&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports